import React from "react";

import SectionFigure from "./SectionFigure";

export default function ProjectSection(props) {
  return (
    <>
      <section className="section-spacing" id={props.sectionID}>
        <div className="container">
          <h2 className="heading-secondary">{props.sectionHeading}</h2>

          <div className="container-figure">
            <div className="grid grid--2-cols grid--2-rows">
              <SectionFigure
                heading="MindGinie"
                listItem1="Get help relieving your stress with the help of experts"
                listItem2="Transition to meditation & mindfulness at a natural pace"
                listItem3="De-stress and focus using scientifically-proven methods"
                appURL="https://mindginie.com"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
